import {
  customerCurrency,
  eplAccessTechOptions,
} from "@/common/const/filter-options";
import { contractTermsOptions } from "@/common/const/types/index.const";
import { FormFieldsStrategyType } from "@/common/types";

const eplQuoteLineFormStrategy: FormFieldsStrategyType[] = [
  {
    label: "Currency",
    name: "targetCurrency",
    required: false,
    readonly: true,
    inputType: "select",
    options: customerCurrency,
  },
  {
    inputType: "text",
    label: "OTC",
    name: "targetOTC",
    required: false,
    readonly: true,
  },
  {
    inputType: "text",
    label: "MRC",
    name: "targetMRC",
    required: false,
    readonly: true,
  },
  {
    inputType: "text",
    label: "Quote Type",
    required: false,
    readonly: true,
    name: "quoteType",
  },
  {
    inputType: "text",
    label: "Last Mile Provider",
    name: "lastMileProvider",
    required: false,
    readonly: true,
  },

  {
    inputType: "text",
    label: "Cable Provider",
    name: "cableProvider",
    required: false,
    readonly: true,
  },
  {
    inputType: "text",
    label: "Bandwidth (in Mbps)",
    name: "bandWidth",
    required: false,
    readonly: true,
    patternMessage: "Value not satisfied range from 0.128 to 10,000",
    pattern:
      /^(?:0\.(?:12[89]|1[3-9]\d|[2-9]\d{1,2})|[1-9]\d{0,3}(?:\.\d{1,3})?|10000(?:\.0{1,3})?)$/,
  },
  {
    inputType: "select",
    label: "Contract Term",
    name: "contractTerm",
    required: false,
    readonly: true,
    options: [...contractTermsOptions],
  },

  {
    inputType: "select",
    label: "Access Technology",
    name: "AccessTechnology",
    required: false,
    readonly: true,
    options: eplAccessTechOptions,
  },
  {
    inputType: "text",
    label: "Lead Time (in Days)",
    name: "leadTeam",
    required: false,
    readonly: true,
  },
  {
    inputType: "text",
    label: "SLA Uptime (in %)",
    name: "SlaUptime",
    required: false,
    readonly: true,
  },
  {
    inputType: "text",
    label: "SLA MTTR (in Hours)",
    name: "SlaMTTR",
    required: false,
    readonly: true,
  },
  {
    inputType: "text",
    label: "SLA Latency (in ms)",
    name: "slaLatency",
    required: false,
    readonly: true,
  },
  {
    inputType: "text",
    label: "Jumbo Frames",
    name: "jumboFrames",
    required: false,
    readonly: true,
  },
  {
    inputType: "text",
    label: "MTU Size (in Bytes)",
    name: "mtuSize",
    required: false,
    readonly: true,
  },
  {
    inputType: "select",
    label: "QinQ Supported",
    name: "qinqSupported",
    required: false,
    readonly: true,
    options: [
      {
        label: "Yes",
        value: "Yes",
      },
      {
        label: "No",
        value: "No",
      },
    ],
  },
  {
    inputType: "select",
    label: "Network Status",
    name: "networkStatus",
    required: false,
    readonly: true,
    options: [
      {
        label: "Off Net",
        value: "OfNet",
      },
      {
        label: "Near Net",
        value: "NearNet",
      },
      {
        label: "On Net",
        value: "OnNet",
      },
    ],
  },
  {
    inputType: "textarea",
    label: "Note",
    name: "description",
    required: false,
  },
];

export default eplQuoteLineFormStrategy;
